import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Layout from '../components/layout/Layout';
import PublicRouter from './PublicRouter';
import PrivateRouter from './PrivateRouter';
import MqttNavigation from './MqttNavigation';
import {
	MainPage,
	LoginPage,
	PlayPage,
	PlayListPage,
	ChatBotPage,
	PlayerPage,
	CustomPage,
	SchoolPage,
	StoragePage,
	NoticePage,
	PlayerV2Page,
	MaintenancePage,
	CalendarPage,
	AiRobotPage,
} from '../pages';

import LoadingImage from '../assets/image/loading/loading.gif';
import AienMainPage from '../pages/aienMainPage/AienMainPage';
import ManageLayout from '../components/layout/ManageLayout';
import PromptLayout from '../components/layout/PromptLayout';
import ScrollToTop from '../components/util/ScrollToTop'; // Measurement ID를 src/Analytics.jsx에서 입력하세요

import AlarmPage from '../pages/alarm/AlarmPage';
import Persona from '../pages/persona/Persona';
import Prompt from '../pages/prompt/Prompt';
import PromptManage from '../pages/promptManage/PromptManage';
import Analytics from '../Analytics';

const is점검중 = false;

const Router = () => {
	if (is점검중) {
		return (
			<BrowserRouter>
				<Routes>
					<Route path='*' element={<MaintenancePage />} />
				</Routes>
			</BrowserRouter>
		);
	}

	return (
		<BrowserRouter>
			<MqttNavigation />
			<Analytics />
			<ScrollToTop />
			<Suspense
				fallback={
					<div
						className='loading'
						style={{
							position: 'fixed',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)',
							textAlign: 'center',
						}}>
						<img src={LoadingImage} width={32} alt='' />
						<br />
						Loading...
					</div>
				}>
				<Routes>
					<Route element={<PrivateRouter />}>
						<Route element={<Layout />}>
							<Route path='/' element={<MainPage />} />
							<Route path='/play' element={<PlayPage />} />
							<Route path='/play/list' element={<PlayListPage />} />
							<Route path='/player' element={<PlayerPage />} />
							<Route path='/playerV2' element={<PlayerV2Page />} />
							<Route path='/school' element={<SchoolPage />} />
							<Route path='/storage' element={<StoragePage />} />
							<Route path='/notice' element={<NoticePage />} />
							<Route path='/aien' element={<AienMainPage />} />
							<Route path='/aien/setp1' element={<AienMainPage />} />
							<Route path='/aien/setp2' element={<AienMainPage />} />
							<Route path='/aien/setp3' element={<AienMainPage />} />
							<Route path='/calendar' element={<CalendarPage />} />
							<Route path='/airobot' element={<AiRobotPage />} />
						</Route>
						<Route element={<ManageLayout />}>
							{/* <Route path='/manage' element={<ManagePage />} /> */}
							<Route path='/manage' element={<PromptManage />} />
							<Route path='/persona' element={<Persona />} />
							<Route path='/custom' element={<CustomPage />} />
							<Route path='/custom/chatbot' element={<ChatBotPage />} />
							<Route path='/alarm' element={<AlarmPage />} />
						</Route>
						<Route element={<PromptLayout />}>
							<Route path='/prompt-manage' element={<PromptManage />} />
							<Route path='/prompt' element={<Prompt />} />
						</Route>
					</Route>
					<Route element={<PublicRouter />}>
						<Route path='/login' element={<LoginPage />} />
					</Route>
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
};

export default Router;
